import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ChooseAdventure } from './components/ChooseAdventure';
import { AboutCollab } from './components/AboutCollab';
import { RainforestSection } from './components/RainforestSection';
import { BluOceanSection } from './components/BluOceanSection';
import { WhyBookUs } from './components/WhyBookUs';
import { ClientRatings } from './components/ClientRatings';
import { Gallery } from './components/Gallery';
import { Packages } from './components/Packages';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyButtons } from './components/StickyButtons';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-sand-light font-sans text-gray-800 overflow-x-hidden" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <ChooseAdventure data-id="element-5" />
          <AboutCollab data-id="element-6" />
          <RainforestSection data-id="element-7" />
          <BluOceanSection data-id="element-8" />
          <WhyBookUs data-id="element-9" />
          <ClientRatings data-id="element-10" />
          <Gallery data-id="element-11" />
          <Packages data-id="element-12" />
          <Reviews data-id="element-13" />
          <Faq data-id="element-14" />
          <FinalCTA data-id="element-15" />
        </main>
        <Footer data-id="element-16" />
        <StickyButtons data-id="element-17" />
      </div>
    </LanguageProvider>;
}